import React from 'react';

import styles from './troy.module.scss';

import { Button, Link, Translation } from '../../components/common';
import NamedAvatar from '../../components/common/NamedAvatar/index.troy';
import { connectTo } from '../../utils';
import { logout } from '../../actions';

class ThanksPage extends React.Component {
  onLogoutClick = () => {
    const { logout } = this.props;
    logout();
  };

  render() {
    const { showGoogleLink } = this.props;
    return (
      <div className={styles['thanks__wrapper']}>
        <div className={styles['thanks__message']}>
          <NamedAvatar />
          <Translation isHtml className={styles['thanks__message-content']}>
            CHECKOUT_THANK_YOU_TOP
          </Translation>
        </div>
        <div className={styles['thanks__controls']}>
          <Button
            id="page.thanks.component.controls.logout-button"
            className={styles['thanks__button']}
            onClick={this.onLogoutClick}
          >
            <Translation>CHECKOUT_THANK_YOU_BUTTON</Translation>
          </Button>
          {showGoogleLink ? (
            <Link
              id="page.thanks.component.controls.redirect-to-google-link"
              className={styles['thanks__link']}
              raw
              to="https://g.page/troy-gmbh/review?rc"
            >
              <Translation keyIfNoValue>CHECKOUT_GOOGLE_REVIEW</Translation>
            </Link>
          ) : null}
        </div>
      </div>
    );
  }
}

export default connectTo(
  ({
    ui: {
      thanks: {
        googleLink: { show: showGoogleLink },
      },
    },
  }) => ({ showGoogleLink }),
  { logout },
  ThanksPage
);
